import { useState, useEffect } from 'react';
import { Users, Heart, GraduationCap, BookOpen, Star, Baby, Palette, Utensils, ClipboardList, Calendar, CreditCard, UserPlus, FileText, Camera } from 'lucide-react';
import usePackages from '../../hooks/usePackages';

/**
 * DATA TYPE ICONS FOR IMPORT/EXPORT
 * Modern UI icons to replace emojis
 */
export function ChildrenIcon({ size = 'md', className = '' }) {
  const sizeClasses = {
    xs: 'w-4 h-4', sm: 'w-5 h-5', md: 'w-6 h-6', lg: 'w-8 h-8', xl: 'w-10 h-10', '2xl': 'w-12 h-12',
  };
  return (
    <span className={`inline-flex items-center justify-center relative ${className}`}>
      <Baby className={`${sizeClasses[size]} text-pink-500`} />
      <Heart className="absolute -top-0.5 -right-0.5 w-2 h-2 text-red-400 fill-red-400" />
    </span>
  );
}

export function ActivitiesIcon({ size = 'md', className = '' }) {
  const sizeClasses = {
    xs: 'w-4 h-4', sm: 'w-5 h-5', md: 'w-6 h-6', lg: 'w-8 h-8', xl: 'w-10 h-10', '2xl': 'w-12 h-12',
  };
  return (
    <span className={`inline-flex items-center justify-center relative ${className}`}>
      <Palette className={`${sizeClasses[size]} text-purple-500`} />
      <Star className="absolute -top-0.5 -right-0.5 w-2 h-2 text-amber-400 fill-amber-400" />
    </span>
  );
}

export function NutritionIcon({ size = 'md', className = '' }) {
  const sizeClasses = {
    xs: 'w-4 h-4', sm: 'w-5 h-5', md: 'w-6 h-6', lg: 'w-8 h-8', xl: 'w-10 h-10', '2xl': 'w-12 h-12',
  };
  return (
    <span className={`inline-flex items-center justify-center relative ${className}`}>
      <Utensils className={`${sizeClasses[size]} text-orange-500`} />
    </span>
  );
}

export function DailyLogsIcon({ size = 'md', className = '' }) {
  const sizeClasses = {
    xs: 'w-4 h-4', sm: 'w-5 h-5', md: 'w-6 h-6', lg: 'w-8 h-8', xl: 'w-10 h-10', '2xl': 'w-12 h-12',
  };
  return (
    <span className={`inline-flex items-center justify-center relative ${className}`}>
      <ClipboardList className={`${sizeClasses[size]} text-blue-500`} />
    </span>
  );
}

export function UsersIcon({ size = 'md', className = '' }) {
  const sizeClasses = {
    xs: 'w-4 h-4', sm: 'w-5 h-5', md: 'w-6 h-6', lg: 'w-8 h-8', xl: 'w-10 h-10', '2xl': 'w-12 h-12',
  };
  return (
    <span className={`inline-flex items-center justify-center relative ${className}`}>
      <Users className={`${sizeClasses[size]} text-indigo-500`} />
    </span>
  );
}

export function CalendarIcon({ size = 'md', className = '' }) {
  const sizeClasses = {
    xs: 'w-4 h-4', sm: 'w-5 h-5', md: 'w-6 h-6', lg: 'w-8 h-8', xl: 'w-10 h-10', '2xl': 'w-12 h-12',
  };
  return (
    <span className={`inline-flex items-center justify-center relative ${className}`}>
      <Calendar className={`${sizeClasses[size]} text-teal-500`} />
    </span>
  );
}

export function DevelopmentIcon({ size = 'md', className = '' }) {
  const sizeClasses = {
    xs: 'w-4 h-4', sm: 'w-5 h-5', md: 'w-6 h-6', lg: 'w-8 h-8', xl: 'w-10 h-10', '2xl': 'w-12 h-12',
  };
  return (
    <span className={`inline-flex items-center justify-center relative ${className}`}>
      <BookOpen className={`${sizeClasses[size]} text-green-500`} />
      <Star className="absolute -top-0.5 -right-0.5 w-2 h-2 text-amber-400 fill-amber-400" />
    </span>
  );
}

export function BMIIcon({ size = 'md', className = '' }) {
  const sizeClasses = {
    xs: 'w-4 h-4', sm: 'w-5 h-5', md: 'w-6 h-6', lg: 'w-8 h-8', xl: 'w-10 h-10', '2xl': 'w-12 h-12',
  };
  return (
    <span className={`inline-flex items-center justify-center ${className}`}>
      <svg className={`${sizeClasses[size]} text-cyan-500`} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
      </svg>
    </span>
  );
}

export function RegistrationIcon({ size = 'md', className = '' }) {
  const sizeClasses = {
    xs: 'w-4 h-4', sm: 'w-5 h-5', md: 'w-6 h-6', lg: 'w-8 h-8', xl: 'w-10 h-10', '2xl': 'w-12 h-12',
  };
  return (
    <span className={`inline-flex items-center justify-center relative ${className}`}>
      <UserPlus className={`${sizeClasses[size]} text-emerald-500`} />
    </span>
  );
}

export function InvoiceIcon({ size = 'md', className = '' }) {
  const sizeClasses = {
    xs: 'w-4 h-4', sm: 'w-5 h-5', md: 'w-6 h-6', lg: 'w-8 h-8', xl: 'w-10 h-10', '2xl': 'w-12 h-12',
  };
  return (
    <span className={`inline-flex items-center justify-center relative ${className}`}>
      <CreditCard className={`${sizeClasses[size]} text-violet-500`} />
    </span>
  );
}

/**
 * Get icon component by data type
 */
export function getDataTypeIcon(dataType) {
  const iconMap = {
    children: ChildrenIcon,
    activities: ActivitiesIcon,
    nutrition: NutritionIcon,
    daily_logs: DailyLogsIcon,
    users: UsersIcon,
    takwim: CalendarIcon,
    development: DevelopmentIcon,
    nutritional_status: BMIIcon,
    registrations: RegistrationIcon,
    invoices: InvoiceIcon,
  };
  return iconMap[dataType] || FileText;
}

/**
 * PARENT ICON COMPONENT
 * Modern UI icon to replace 👨‍👩‍👧 emoji
 */
export function ParentIcon({ size = 'md', className = '' }) {
  const sizeClasses = {
    xs: 'w-4 h-4',
    sm: 'w-5 h-5',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-10 h-10',
    '2xl': 'w-12 h-12',
  };
  
  return (
    <span className={`inline-flex items-center justify-center relative ${className}`}>
      <Users className={`${sizeClasses[size]} text-pink-500`} />
      <Heart className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 text-red-500 fill-red-500" />
    </span>
  );
}

/**
 * TEACHER ICON COMPONENT
 * Modern UI icon to replace 👩‍🏫 emoji
 */
export function TeacherIcon({ size = 'md', className = '' }) {
  const sizeClasses = {
    xs: 'w-4 h-4',
    sm: 'w-5 h-5',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-10 h-10',
    '2xl': 'w-12 h-12',
  };
  
  const starSizes = {
    xs: 'w-2 h-2',
    sm: 'w-2.5 h-2.5',
    md: 'w-3 h-3',
    lg: 'w-3.5 h-3.5',
    xl: 'w-4 h-4',
    '2xl': 'w-5 h-5',
  };
  
  return (
    <span className={`inline-flex items-center justify-center relative ${className}`}>
      <GraduationCap className={`${sizeClasses[size]} text-emerald-500`} />
      <Star className={`absolute -top-0.5 -right-0.5 ${starSizes[size]} text-amber-400 fill-amber-400`} />
    </span>
  );
}

/**
 * PARENT BADGE - Styled badge with icon
 */
export function ParentBadge({ text = 'Ibu Bapa', variant = 'default' }) {
  const variants = {
    default: 'bg-gradient-to-r from-pink-100 to-purple-100 text-pink-700 border-pink-200',
    solid: 'bg-gradient-to-r from-pink-500 to-purple-500 text-white',
    outline: 'bg-transparent border-2 border-pink-400 text-pink-600',
  };
  
  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-bold ${variants[variant]}`}>
      <ParentIcon size="sm" />
      {text}
    </span>
  );
}

/**
 * TEACHER BADGE - Styled badge with icon
 */
export function TeacherBadge({ text = 'Pendidik', variant = 'default' }) {
  const variants = {
    default: 'bg-gradient-to-r from-emerald-100 to-teal-100 text-emerald-700 border-emerald-200',
    solid: 'bg-gradient-to-r from-emerald-500 to-teal-500 text-white',
    outline: 'bg-transparent border-2 border-emerald-400 text-emerald-600',
  };
  
  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-bold ${variants[variant]}`}>
      <TeacherIcon size="sm" />
      {text}
    </span>
  );
}

/**
 * COLORFUL FLOATING ELEMENTS
 * Tema: Warna-warni & Ceria!
 */
export function FloatingElements({ variant = 'default' }) {
  // CANDY CLOUD: gelembung lembut terapung (pink/lilac/biru/oren/teal)
  const bubbles = [
    { left: '6%', top: '18%', size: 46, color: '#F472B6' },
    { left: '88%', top: '22%', size: 58, color: '#C084FC' },
    { left: '76%', top: '72%', size: 40, color: '#60A5FA' },
    { left: '12%', top: '66%', size: 52, color: '#2DD4BF' },
    { left: '92%', top: '55%', size: 34, color: '#FB923C' },
    { left: '30%', top: '86%', size: 44, color: '#F9A8D4' },
    { left: '55%', top: '10%', size: 36, color: '#C4B5FD' },
    { left: '42%', top: '75%', size: 30, color: '#F472B6' },
    { left: '68%', top: '40%', size: 26, color: '#2DD4BF' },
    { left: '20%', top: '38%', size: 32, color: '#C084FC' },
  ];

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
      {/* Gelembung Candy Terapung */}
      {bubbles.map((b, i) => (
        <div
          key={`bubble-${i}`}
          className="absolute rounded-full"
          style={{
            left: b.left,
            top: b.top,
            width: b.size,
            height: b.size,
            background: `radial-gradient(circle at 32% 30%, rgba(255,255,255,0.95), ${b.color}26)`,
            border: `1.5px solid ${b.color}40`,
            animation: `candyBubbleFloat ${4 + (i % 4)}s ease-in-out infinite, candyBubbleDrift ${8 + (i % 3) * 2}s ease-in-out infinite`,
            animationDelay: `${i * 0.4}s`,
          }}
        />
      ))}

      {/* Blob pastel lembut */}
      <div className="absolute top-10 left-10 w-44 h-44 rounded-full blur-3xl" style={{ background: 'rgba(244,114,182,0.14)', animation: 'pulseBlob 5s ease-in-out infinite' }} />
      <div className="absolute top-32 right-16 w-52 h-52 rounded-full blur-3xl" style={{ background: 'rgba(192,132,252,0.14)', animation: 'pulseBlob 6s ease-in-out infinite', animationDelay: '1s' }} />
      <div className="absolute bottom-16 left-1/4 w-48 h-48 rounded-full blur-3xl" style={{ background: 'rgba(96,165,250,0.12)', animation: 'pulseBlob 5.5s ease-in-out infinite', animationDelay: '2s' }} />
      <div className="absolute bottom-28 right-1/3 w-40 h-40 rounded-full blur-3xl" style={{ background: 'rgba(45,212,191,0.12)', animation: 'pulseBlob 4.5s ease-in-out infinite', animationDelay: '0.5s' }} />

      <style>{`
        @keyframes candyBubbleFloat {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(-14px) scale(1.04); }
        }
        @keyframes candyBubbleDrift {
          0%, 100% { margin-left: 0; }
          33% { margin-left: 8px; }
          66% { margin-left: -6px; }
        }
        @keyframes pulseBlob {
          0%, 100% { opacity: 0.3; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.15); }
        }
      `}</style>
    </div>
  );
}


/**
 * COLORFUL STAT CARD
 */
export function AnimatedStatCard({ 
  icon: Icon, 
  emoji,
  iconComponent: IconComponent, // Allow passing a component like ParentIcon
  label, 
  value, 
  color = 'red',
  delay = 0,
  onClick 
}) {
  const [displayValue, setDisplayValue] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  useEffect(() => {
    if (!isVisible) return;
    const numValue = parseInt(value) || 0;
    if (numValue === 0) { setDisplayValue(0); return; }
    
    let start = 0;
    const increment = numValue / 60;
    const timer = setInterval(() => {
      start += increment;
      if (start >= numValue) {
        setDisplayValue(numValue);
        clearInterval(timer);
      } else {
        setDisplayValue(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [value, isVisible]);

  const colorConfig = {
    red: { bg: '#F472B6', light: '#FCE7F3' },
    orange: { bg: '#FB923C', light: '#FFEDD5' },
    yellow: { bg: '#FB923C', light: '#FFEDD5' },
    green: { bg: '#2DD4BF', light: '#CCFBF1' },
    blue: { bg: '#60A5FA', light: '#DBEAFE' },
    purple: { bg: '#C084FC', light: '#F3E8FF' },
    pink: { bg: '#F472B6', light: '#FCE7F3' },
    cyan: { bg: '#2DD4BF', light: '#CCFBF1' },
  };

  const config = colorConfig[color] || colorConfig.red;

  return (
    <div
      onClick={onClick}
      className={`
        relative overflow-hidden rounded-3xl p-5
        transition-all duration-500 ease-out
        ${onClick ? 'cursor-pointer' : ''}
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}
        hover:-translate-y-1.5
        group
      `}
      style={{ 
        transitionDelay: `${delay}ms`,
        background: '#FBF3F8',
        boxShadow: '8px 8px 18px rgba(214,188,214,0.55), -8px -8px 18px rgba(255,255,255,0.95)',
      }}
    >
      {/* Icon */}
      <div 
        className="w-12 h-12 rounded-full flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300"
        style={{ background: `linear-gradient(135deg, ${config.bg}, ${config.bg}BB)`, boxShadow: `0 6px 14px ${config.bg}55` }}
      >
        {IconComponent ? (
          <IconComponent size="lg" />
        ) : emoji ? (
          <span className="text-2xl">{emoji}</span>
        ) : Icon ? (
          <Icon className="w-6 h-6 text-white" strokeWidth={2.2} />
        ) : null}
      </div>
      
      <p className="text-4xl font-black mb-1" style={{ color: '#701A75' }}>{displayValue}</p>
      <p className="text-xs font-bold" style={{ color: '#A78BAB' }}>{label}</p>
    </div>
  );
}

/**
 * COLORFUL HEADER
 */
export function AnimatedHeader({ icon, emoji, iconComponent: IconComponent, customIcon, title, subtitle, delay = 0, gradient }) {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  // Default gradient or custom - Candy Cloud pastel
  const bgGradient = gradient || 'linear-gradient(135deg, #F9A8D4 0%, #C084FC 100%)';

  return (
    <div className={`flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6 transition-all duration-700 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}>
      <div className="relative flex-shrink-0">
        <div 
          className="w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center"
          style={{ 
            background: bgGradient,
            boxShadow: '0 6px 14px rgba(244,114,182,0.35)',
            animation: 'wiggleIcon 3s ease-in-out infinite'
          }}
        >
          {customIcon ? (
            customIcon
          ) : IconComponent ? (
            <IconComponent size="lg" className="text-white" />
          ) : emoji ? (
            <span className="text-xl sm:text-2xl">{emoji}</span>
          ) : icon}
        </div>
        {/* Sparkle */}
        <div className="absolute -top-1 -right-1 text-sm sm:text-base" style={{ animation: 'sparkle 1.5s ease-in-out infinite' }}>✨</div>
      </div>
      <div className="min-w-0 flex-1">
        <h1 
          className="text-xl sm:text-2xl lg:text-3xl font-black truncate"
          style={{ 
            fontFamily: "'Quicksand', sans-serif",
            fontWeight: 700,
            color: '#701A75',
          }}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-xs sm:text-sm font-medium truncate" style={{ color: '#A78BAB' }}>
            {subtitle}
          </p>
        )}
      </div>
      
      <style>{`
        @keyframes wiggleIcon {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(-5deg); }
          75% { transform: rotate(5deg); }
        }
        @keyframes sparkle {
          0%, 100% { opacity: 1; transform: scale(1) rotate(0deg); }
          50% { opacity: 0.5; transform: scale(1.3) rotate(180deg); }
        }
      `}</style>
    </div>
  );
}

/**
 * COLORFUL QUICK ACTION BUTTON
 */
export function QuickActionButton({ icon: Icon, emoji, iconComponent: IconComponent, label, sublabel, color = 'red', onClick, delay = 0 }) {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  const colorConfig = {
    red: { light: '#FCE7F3', fg: '#DB2777' },
    orange: { light: '#FFEDD5', fg: '#EA580C' },
    yellow: { light: '#FFEDD5', fg: '#EA580C' },
    green: { light: '#CCFBF1', fg: '#0D9488' },
    blue: { light: '#DBEAFE', fg: '#2563EB' },
    purple: { light: '#F3E8FF', fg: '#9333EA' },
    pink: { light: '#FCE7F3', fg: '#DB2777' },
    cyan: { light: '#CCFBF1', fg: '#0D9488' },
  };

  const config = colorConfig[color] || colorConfig.red;

  return (
    <button
      onClick={onClick}
      className={`
        group p-5 rounded-3xl
        transition-all duration-300 text-left
        hover:-translate-y-1.5
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}
      `}
      style={{
        transitionDelay: `${delay}ms`,
        background: '#FBF3F8',
        boxShadow: '8px 8px 18px rgba(214,188,214,0.55), -8px -8px 18px rgba(255,255,255,0.95)',
        borderRadius: '24px',
      }}
    >
      <div
        className="w-12 h-12 rounded-full flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300"
        style={{ background: config.light }}
      >
        {IconComponent ? (
          <IconComponent size="lg" />
        ) : emoji ? (
          <span className="text-2xl">{emoji}</span>
        ) : Icon ? (
          <Icon className="w-6 h-6" style={{ color: config.fg }} />
        ) : null}
      </div>
      <p className="font-bold text-lg" style={{ color: '#701A75' }}>{label}</p>
      {sublabel && <p className="text-sm" style={{ color: '#A78BAB' }}>{sublabel}</p>}
    </button>
  );
}

/**
 * COLORFUL GREETING BANNER - TIME-BASED THEME
 * Morning (6am-12pm): Sunrise theme with warm colors
 * Afternoon (12pm-5pm): Bright sunny theme
 * Evening (5pm-8pm): Sunset/dusk theme
 * Night (8pm-6am): Dark night theme with stars
 */
// Format senarai nama anak: "ADAM", "ADAM & AISYAH", "ADAM, AISYAH & DANIAL"
const formatChildNames = (names) => {
  if (!names || names.length === 0) return '';
  if (names.length === 1) return names[0];
  return `${names.slice(0, -1).join(', ')} & ${names[names.length - 1]}`;
};

export function GreetingBanner({ userName, role, userPhoto, childNames = [] }) {
  const [greeting, setGreeting] = useState('');
  const [emoji, setEmoji] = useState('');
  const [bgColor, setBgColor] = useState('');
  const [isNightTime, setIsNightTime] = useState(false);
  const [tagline, setTagline] = useState('');
  const [childMessage, setChildMessage] = useState('');
  const namesKey = (childNames || []).join('|');
  
  useEffect(() => {
    const hour = new Date().getHours();
    const names = formatChildNames(namesKey ? namesKey.split('|') : []);
    
    if (hour >= 6 && hour < 12) {
      // MORNING (6am - 12pm)
      setGreeting('Selamat Pagi');
      setEmoji('🌅');
      setBgColor('from-[#FDE7F3] via-[#FCE1F0] to-[#F0E5FB]');
      setTagline('🌻 Jom mulakan hari dengan semangat!');
      setChildMessage(names ? `💕 Semoga ${names} ceria di taska hari ini!` : '');
      setIsNightTime(false);
    } else if (hour >= 12 && hour < 17) {
      // AFTERNOON (12pm - 5pm)
      setGreeting('Selamat Petang');
      setEmoji('☀️');
      setBgColor('from-[#FFF0E3] via-[#FDE7F3] to-[#F0E5FB]');
      setTagline('🎉 Jom belajar sambil bermain!');
      setChildMessage(names ? `💕 Jom lihat aktiviti ${names} hari ini!` : '');
      setIsNightTime(false);
    } else if (hour >= 17 && hour < 20) {
      // EVENING/DUSK (5pm - 8pm)
      setGreeting('Selamat Petang');
      setEmoji('🌇');
      setBgColor('from-[#FCE1F0] via-[#EFDDFA] to-[#E4E4FB]');
      setTagline('🌷 Semoga hari anda menyenangkan!');
      setChildMessage(names ? `💕 Jom imbas perkembangan ${names} hari ini!` : '');
      setIsNightTime(false);
    } else {
      // NIGHT (8pm - 6am)
      setGreeting('Selamat Malam');
      setEmoji('🌙');
      setBgColor('from-[#4A2B5C] via-[#5B3672] to-[#6D4394]');
      setTagline('⭐ Rehat yang cukup untuk hari esok!');
      setChildMessage(names ? `💕 Selamat malam buat ${names}, mimpi indah!` : '');
      setIsNightTime(true);
    }
  }, [childNames]);

  // Role icon rendering - use custom icons for ibu_bapa and guru
  const getRoleIcon = (userRole) => {
    if (userRole === 'ibu_bapa') {
      return <ParentIcon size="lg" className="drop-shadow-md" />;
    }
    if (userRole === 'guru') {
      return <TeacherIcon size="lg" className="drop-shadow-md" />;
    }
    const roleEmoji = {
      admin: '👨‍💼',
      superadmin: '👑',
      branch_manager: '🏢',
    };
    return <span className="text-2xl">{roleEmoji[userRole] || '👤'}</span>;
  };

  return (
    <div 
      className={`relative overflow-hidden bg-gradient-to-r ${bgColor} rounded-3xl p-6 mb-6`}
      style={{ animation: 'slideIn 0.6s ease-out', border: '1px solid #E4DFF4', boxShadow: '0 6px 20px rgba(43,46,107,0.10)' }}
    >
      {/* Decorative elements based on time */}
      {isNightTime ? (
        <>
          {/* Night theme - Stars */}
          <div className="absolute top-2 right-8 w-2 h-2 bg-white rounded-full animate-pulse" />
          <div className="absolute top-6 right-16 w-1 h-1 bg-yellow-200 rounded-full animate-pulse" style={{ animationDelay: '0.3s' }} />
          <div className="absolute top-4 right-32 w-1.5 h-1.5 bg-white rounded-full animate-pulse" style={{ animationDelay: '0.6s' }} />
          <div className="absolute top-10 right-24 w-1 h-1 bg-blue-200 rounded-full animate-pulse" style={{ animationDelay: '0.9s' }} />
          <div className="absolute top-3 right-48 w-2 h-2 bg-yellow-100 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }} />
          <div className="absolute bottom-8 right-12 w-1 h-1 bg-white rounded-full animate-pulse" style={{ animationDelay: '0.7s' }} />
          <div className="absolute bottom-4 right-40 w-1.5 h-1.5 bg-blue-100 rounded-full animate-pulse" style={{ animationDelay: '0.5s' }} />
          {/* Moon glow */}
          <div className="absolute top-0 right-0 w-24 h-24 bg-yellow-100/10 rounded-full blur-xl" />
        </>
      ) : (
        <>
          {/* Day theme - Decorative circles */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/20 rounded-full -translate-y-1/2 translate-x-1/2" />
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/20 rounded-full translate-y-1/2 -translate-x-1/2" />
          <div className="absolute top-1/2 right-1/4 w-16 h-16 bg-white/10 rounded-full" />
        </>
      )}
      
      <div className="relative flex items-center gap-4">
        {/* User Photo or Emoji */}
        <div 
          className="relative"
          style={{ animation: 'bounceEmoji 2s ease-in-out infinite' }}
        >
          {userPhoto ? (
            <div className="relative">
              <img 
                src={userPhoto} 
                alt={userName}
                className={`w-16 h-16 rounded-full object-cover border-4 shadow-lg ${isNightTime ? 'border-indigo-300/50' : 'border-white/50'}`}
              />
              <span className="absolute -bottom-1 -right-1 text-2xl">{emoji}</span>
            </div>
          ) : (
            <div className={`w-16 h-16 rounded-full backdrop-blur-sm flex items-center justify-center border-4 shadow-lg ${isNightTime ? 'bg-indigo-500/30 border-indigo-300/50' : 'bg-white/30 border-white/50'}`}>
              <span className="text-4xl">{emoji}</span>
            </div>
          )}
        </div>
        <div className={isNightTime ? 'text-indigo-100' : ''} style={{ flex: 1, color: isNightTime ? undefined : '#2B2E6B' }}>
          <p className={`font-bold ${isNightTime ? 'text-indigo-200' : ''}`} style={!isNightTime ? { color: '#7357C9' } : {}}>{greeting}</p>
          <h2 className="text-2xl md:text-3xl font-black flex items-center gap-2">
            {userName} {getRoleIcon(role)}
          </h2>
          <p className={`font-bold mt-1 ${isNightTime ? 'text-indigo-200' : ''}`} style={!isNightTime ? { color: '#7B75A0' } : {}}>{tagline}</p>
          {childMessage && (
            <p
              className={`font-bold mt-1 text-sm md:text-base ${isNightTime ? 'text-pink-200' : ''}`}
              style={!isNightTime ? { color: '#C0397F' } : {}}
              data-testid="greeting-child-message"
            >
              {childMessage}
            </p>
          )}
        </div>
      </div>
      
      <style>{`
        @keyframes slideIn {
          from { transform: translateX(-30px); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        @keyframes bounceEmoji {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          25% { transform: translateY(-10px) rotate(-5deg); }
          75% { transform: translateY(-5px) rotate(5deg); }
        }
      `}</style>
    </div>
  );
}

/**
 * COLORFUL ANIMATED CARD
 */
export function AnimatedCard({ children, className = '', delay = 0, color = 'red', onClick }) {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  const colorConfig = {
    red: '#F472B6',
    orange: '#FB923C',
    yellow: '#FDBA74',
    green: '#2DD4BF',
    blue: '#60A5FA',
    purple: '#C084FC',
    pink: '#F9A8D4',
    cyan: '#2DD4BF',
  };

  return (
    <div
      onClick={onClick}
      className={`
        relative overflow-hidden rounded-2xl sm:rounded-3xl p-4 sm:p-6
        transition-all duration-500 ease-out
        ${onClick ? 'cursor-pointer' : ''}
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}
        hover:-translate-y-1
        ${className}
      `}
      style={{ 
        transitionDelay: `${delay}ms`,
        background: '#FBF3F8',
        boxShadow: '8px 8px 18px rgba(214,188,214,0.55), -8px -8px 18px rgba(255,255,255,0.95)',
      }}
    >
      {/* Candy top bar */}
      <div className="absolute top-0 left-0 right-0 h-1" style={{ background: 'linear-gradient(90deg, #F9A8D4 0%, #C084FC 40%, #93C5FD 80%, #99F6E4 100%)' }} />
      {children}
    </div>
  );
}

/**
 * COLORFUL CHILD CARD
 */
export function ChildCard({ child, onClick, delay = 0, onPhotoUpload, uploadingPhoto }) {
  const [isVisible, setIsVisible] = useState(false);
  const { getPackage } = usePackages();
  const pkgInfo = getPackage(child.package);
  const colors = ['#F04A83', '#FFC93C', '#FFDD75', '#6FE7DD', '#7A5FB5', '#9178D6'];
  const randomColor = colors[Math.floor(Math.random() * colors.length)];
  
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  const handlePhotoChange = (e) => {
    if (e.target.files[0] && onPhotoUpload) {
      onPhotoUpload(child.id, e.target.files[0]);
    }
  };

  return (
    <div
      onClick={onClick}
      className={`
        relative overflow-hidden p-5 rounded-3xl bg-white
        cursor-pointer hover:shadow-2xl hover:-translate-y-3 hover:rotate-1
        transition-all duration-500
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}
        group
      `}
      style={{ 
        transitionDelay: `${delay}ms`,
        border: `4px solid ${randomColor}`,
      }}
    >
      {/* Rainbow bar */}
      <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-red-400 via-yellow-400 via-green-400 via-blue-400 to-purple-400" />
      
      {/* Decorative stars */}
      <div className="absolute top-3 right-3 text-xl opacity-0 group-hover:opacity-100 transition-opacity" style={{ animation: 'spinStar 2s linear infinite' }}>⭐</div>
      
      {/* Photo */}
      <div className="relative mx-auto mb-4 w-24 h-24">
        <div 
          className="absolute inset-0 rounded-full blur-lg opacity-50 group-hover:opacity-70 transition-opacity"
          style={{ background: `linear-gradient(135deg, ${randomColor} 0%, #FFDD75 100%)` }}
        />
        {child.photo_url ? (
          <img 
            src={child.photo_url} 
            alt={child.name}
            className="relative w-24 h-24 rounded-full object-cover border-4 border-white shadow-xl group-hover:scale-110 transition-transform duration-300"
          />
        ) : (
          <div 
            className="relative w-24 h-24 rounded-full flex items-center justify-center border-4 border-white shadow-xl group-hover:scale-110 transition-transform duration-300"
            style={{ background: `linear-gradient(135deg, ${randomColor} 0%, #FFDD75 100%)` }}
          >
            <span className="text-4xl">👶</span>
          </div>
        )}
        
        {/* Photo upload button */}
        {onPhotoUpload && (
          <label 
            className="absolute bottom-0 right-0 p-2 bg-gradient-to-r from-blue-400 to-blue-500 hover:from-blue-500 hover:to-blue-600 text-white rounded-full cursor-pointer opacity-0 group-hover:opacity-100 transition-all shadow-lg hover:scale-110"
            onClick={(e) => e.stopPropagation()}
          >
            {uploadingPhoto === child.id ? (
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <Camera className="w-4 h-4" />
            )}
            <input
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handlePhotoChange}
              disabled={uploadingPhoto === child.id}
            />
          </label>
        )}
        
        {/* Online indicator */}
        <div className="absolute bottom-1 right-8 w-5 h-5 bg-green-400 rounded-full border-2 border-white shadow-lg" style={{ animation: 'pulse 2s infinite' }} />
      </div>
      
      {/* Info */}
      <h3 className="font-black text-xl text-gray-800 text-center mb-1">{child.name}</h3>
      <p className="text-sm font-bold text-center" style={{ color: randomColor }}>{child.class_name || 'Kelas belum ditetapkan'}</p>
      <p className="text-xs text-gray-500 text-center mt-1 font-bold">🎂 {child.dob}</p>
      
      {/* Package badge (nama dinamik dari Pakej Langganan superadmin) */}
      {child.package && pkgInfo && (
        <div className="flex justify-center mt-3">
          <span 
            className="text-xs px-4 py-1.5 rounded-full font-bold text-white"
            style={{ backgroundColor: pkgInfo.color || '#9178D6' }}
          >
            {pkgInfo.emoji} {pkgInfo.name}
          </span>
        </div>
      )}
      
      <style>{`
        @keyframes spinStar {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.2); opacity: 0.7; }
        }
      `}</style>
    </div>
  );
}
